<template>
  <div
    v-if="!redemptionUltimateFailureReason"
    class="w-full flex-1-0-auto viewport-gutter pt-6 pb-16 bg-gray-100 border-t border-b border-gray-200 xl:pt-8 xl:pb-24"
  >
    <div class="container">
      <form class="w-full max-w-xl m-0" @submit.prevent="onSubmit">
        <div v-if="errors.length" class="w-full flex border border-gray-300 bg-white p-4 mt-2 mb-4">
          <div class="w-8 flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" v-bind:svg-inline="''" v-bind:class="'w-4.5 h-4.5'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.6 0H5.269L0 5.4v7.2L5.4 18h7.2l5.4-5.4V5.4zm1.665 12.189l-2.121 2.121-3.189-3.19-3.189 3.19-2.122-2.121L6.837 9l-3.19-3.189 2.122-2.122 3.189 3.19 3.189-3.19 2.121 2.122L11.08 9z" fill="#c00"/></svg>
          </div>
          <div class="pt-2px xl:pt-0">
            <p class="font-bold text-sm leading-none pb-2 xl:text-lg">
              {{ $t(`errors.type.${firstErrorKey}.title`, brandInfo) }}
            </p>
            <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${firstErrorKey}.description`, brandInfo)" />
          </div>
        </div>

        <FormInput
          v-model.trim="voucherCode"
          :placeholder="$t('components.form.flightvoucherCode.placeholder')"
          :label="$t('components.form.flightvoucherCode.label')"
          :valid="!$v.voucherCode.$error"
          :error-string="$t('components.form.error.voucherCode')"
          extra-class="mb-5"
        />

        <div class="flex pt-8">
          <Button variant="secondary" :loading="loading" full-width>
            {{ $t('pages.redemption.submitButton') }}
          </Button>
        </div>
      </form>
    </div>
  </div>
  <Loading v-else class="bg-gray-100">
    <p class="max-w-sm mx-auto text-center pt-6 xl:pt-12">
      {{ $t(`errors.type.${errors[0]}.title`) }}
      <br>
      {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
    </p>
    <p class="max-w-sm mx-auto text-center pt-2">
      {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
    </p>
  </Loading>
</template>

<script lang="ts">
import Form from '~psp-pages/base/home/form.ts'

import Button from '~brand-components/lufthansa/button/button.vue'
import FormInput from '~brand-components/lufthansa/form-input/form-input.vue'
import Loading from '~brand-components/lufthansa/loading/loading.vue'

export default Form.extend({
  components: {
    Button,
    FormInput,
    Loading,
  },
})
</script>
